<template>
    <div class="default">
        <div class="header-title">404 No encontrado</div>
        <div class="header-subtitle">La dirección que buscas no existe</div>
        <img src="@/assets/desktop-error-404.svg" alt="error404" class="error-img">
        <div>
            <button class="red-button" @click="back()">volver al inicio</button>
        </div>
        <img src="@/assets/notros-logo.svg" alt="error404" class="logo-img">
        
    </div>
</template>

<script>
export default {
    name: 'errorlayout',
    methods:{
        back: function(){
            this.$router.push({path: "/resumen"})
        }
    }
    
}
</script>

<style lang="sass">
body
    margin: 0
    padding: 0
    background: #231e30

.default
    margin: 0
    padding: 0
    height: 100%
    width: 100%

.error-img
    display: block
    margin-left: auto
    margin-right: auto

.logo-img
    width: 54px
    height: 30px
    margin-top: 50px
    display: block
    margin-left: auto
    margin-right: auto

.header-title
    color: #ffffff
    font-family: Montserrat
    font-size: 52px
    font-weight: bold
    padding-top: 50px
    position: relative
    width: 100%
    text-align: center

.header-subtitle
    color: #ffffff
    font-family: Montserrat
    font-size: 32px
    font-weight: 600
    padding-top: 50px
    position: relative
    width: 100%
    text-align: center

.red-button
    width: 344px
    height: 56px
    border-radius: 8px
    background-color: #e94c2c
    font-family: Montserrat
    font-size: 22px
    font-weight: bold
    font-stretch: normal
    font-style: normal
    line-height: 0.82
    letter-spacing: normal
    text-align: center
    color: #ffffff
    border: 0
    display: block
    margin-left: auto
    margin-right: auto
    cursor: pointer
    
</style>
